import styled from "styled-components";
import { Header } from "../home-page/landing/landing.components";
import { articles } from "../../knowledge-base-articles";
import ArticleTile from "./article-tile";
import { responsive } from "../../media-quries";
import { Helmet } from "react-helmet";

const Container = styled.div`
  margin-top: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const SubTitle = styled.p`
  max-width: 90%;
  text-align: center;
  color: gray;
`;

const ArticlesTilesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 60px 0;
  width: 100%;
  gap: 24px;

  ${responsive.sm`
    justify-content: center;
  `}
`;

function KnowledgeBase({ title = 'Baza wiedzy GeoKsiegi', ignore }) {
    return (
        <Container>
            {!ignore && <Helmet>
                <title>{title}</title>
                <meta
                    name="description"
                    content="Witaj w centrum wiedzy serwisu GeoKsiegi, gdzie znajdziesz artykuły i poradniki dotyczące ksiąg wieczystych oraz zagadnień związanych z rynkiem nieruchomości."
                />
                <meta
                    name="keywords"
                    content="księgi wieczyste, baza wiedzy, GeoKsiegi, nieruchomości, poradniki, informacje"
                />
            </Helmet>}
            <Header>{title}</Header>
            <SubTitle>
                Witaj w centrum wiedzy serwisu GeoKsiegi, Twojej dedykowanej sekcji blogowej, w której poruszamy tematy związane
                z księgami wieczystymi oraz innymi zagadnieniami z rynku nieruchomości.
            </SubTitle>
            <ArticlesTilesContainer>
                {articles
                    .filter((article) => article.title !== ignore)
                    .map((article) => (
                        <ArticleTile key={article.url} {...article} />
                    ))}
            </ArticlesTilesContainer>
        </Container>
    );
}

export default KnowledgeBase;
